module.exports = __webpack_public_path__ + "img/user-men.43b0f617.svg";